module.exports = "h1{\r\n    margin: 12rem 0;\r\n}\r\n"